import ExclamationMark from "./Exclamation_mark";
export default ExclamationMark;